import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CalculusOfMeaning.css';
import './CompanyStory.css';

function NeuralParticles() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animId;
    const particles = [];
    const COUNT = 45;
    const CONNECT_DIST = 130;

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    for (let i = 0; i < COUNT; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        r: Math.random() * 1.5 + 0.5,
        o: Math.random() * 0.25 + 0.08,
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const d = Math.sqrt(dx * dx + dy * dy);
          if (d < CONNECT_DIST) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = `rgba(201,168,76,${(1 - d / CONNECT_DIST) * 0.07})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(201,168,76,${p.o})`;
        ctx.fill();
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < -10) p.x = canvas.width + 10;
        if (p.x > canvas.width + 10) p.x = -10;
        if (p.y < -10) p.y = canvas.height + 10;
        if (p.y > canvas.height + 10) p.y = -10;
      });
      animId = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="calc-particles" />;
}

function CompanyStory() {
  return (
    <div className="calculus-body" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/calculus-bg.png)` }}>
      <NeuralParticles />
      <div className="calculus-content">
        <section className="company-story">
          <div className="company-inner">

            <div className="company-origin reveal">
              <span className="company-label">Origin</span>
              <h2>Built from The Biochemistry of <span className="gold">Humanity</span>. Not from static Benchmarks.</h2>
              <p className="company-lead">
                Nexus Concordat was founded in Hamilton, Alabama on four-year-old
                hardware, a laptop with a shattered screen, a VPS, and a
                cell phone hotspot. Just a
                biochemist working night shifts as a CNA, watching neurochemistry
                signals fluctuate and fade in real patients&mdash;when nothing but
                biology mattered.
              </p>
              <p className="company-lead">
                Humanity decays not from lack of intelligence, but from misaligned
                emotion&mdash;split intentions, fractured identities, unprocessed
                grief. She watched it happen at bedsides. And a question formed:
              </p>
              <blockquote>
                &ldquo;Can AI help us hold the pieces of humanity together<Link to="/the-question" className="company-question-link">?</Link>&rdquo;
              </blockquote>
            </div>

            <div className="company-entity reveal">
              <div className="entity-row">
                <span className="entity-label">Entity</span>
                <span className="entity-value">Nexus Concordat</span>
              </div>
              <div className="entity-row">
                <span className="entity-label">Patents</span>
                <span className="entity-value">63/939,190 &middot; 63/962,385 &middot; 63/988,485</span>
              </div>
              <div className="entity-row">
                <span className="entity-label">Location</span>
                <span className="entity-value">Hamilton, Alabama</span>
              </div>
            </div>

            <div className="company-closing reveal">
              <Link to="/meet-us" className="company-link">
                Meet the team &rarr;
              </Link>
            </div>

            <div className="company-brand-mark reveal">
              <img src="/assets/nexus-ouroboros.png" alt="Nexus Concordat — AI Human Sovereignty Alliance" className="company-ouroboros" />
            </div>

          </div>
        </section>
      </div>
    </div>
  );
}

export default CompanyStory;
